export default "__VITE_ASSET__D0icKlhK__"